import { Schema } from "@effect/schema";
import { ProtocolKey, ProtocolKeySlug } from "@silo/types";
import { Effect, pipe } from "effect";

export function getProtocolStaticMarketsFileName(protocolKey: ProtocolKey) {
  return pipe(
    protocolKey,
    Schema.encode(ProtocolKeySlug),
    Effect.andThen((slug) => `${slug}.json`)
  );
}
